import env from '../../utils/env';

function handleUnauthorizedReq() {
  window.location.replace(`https://login.${env.hostname}?origin=${window.location.href}`);
  // Returning a promise that never resolves so that we can await this function call,
  // which allows us to ensure that no code is executed after this function returns.
  // In doing so, we eliminate a possible race condition where a later line of code
  // could send the user to a page other than the login page, like the oops page.
  return new Promise(() => null);
}

async function request(
  path: string,
  method = 'GET',
  headers: Record<string, string> = {},
  body: BodyInit | undefined | null = undefined,
  json = true,
  parseResponse = true,
) {
  const defaultHeaders = {
    'FFF-Auth': 'V1.1',
    Origin: env.hostname,
  };

  const response = await fetch(path, {
    credentials: 'include',
    headers: { ...headers, ...defaultHeaders },
    data: {
      activatedOn: true,
    },
    body,
    mode: 'cors',
    method,
  });

  if (!parseResponse) return response;

  if (response.ok && method === 'DELETE') return '';

  if (path.match(/ace-api/) && response.status === 401) {
    await handleUnauthorizedReq();
  }

  if (!response.ok) {
    const errorText = await response.text();
    throw errorText;
  }
  const parsedResponse = json ? response.json() : response.text();
  return parsedResponse;
}

export default request;
